const locations = [
  { lat: 37.5585, lng: 126.9436, title: '서울시 동작구' },
  { lat: 37.541, lng: 127.0568, title: '서울시 강남구' },
  { lat: 37.5744, lng: 126.9769, title: '서울시 종로구' },
  { lat: 37.6016, lng: 127.0404, title: '서울시 성북구' },
];

const middlePoint = { lat: 37.568875, lng: 127.004425, title: '중간지점' };
export { locations, middlePoint };
